import { useFormik } from "formik";
import { useState, useEffect } from "react";
import { Link as RouterLink } from "react-router-dom";
import { Container, Stack, Typography, Button } from "@mui/material";
import { getDocs, collection } from "firebase/firestore";
import { db } from "../firebase"; // Import Firebase db
import Page from "../components/Page";
import AddProduct from "./AddProduct";
import {
  ProductSort,
  ProductList,
  ProductCartWidget,
  ProductFilterSidebar,
} from "../sections/@dashboard/products";
import Iconify from "../components/Iconify";

// ----------------------------------------------------------------------

export default function EcommerceShop() {
  const [openFilter, setOpenFilter] = useState(false);
  const [open, setOpen] = useState(false);
  const [products, setProducts] = useState([]);
  const [allProducts, setAllProducts] = useState([]);

  useEffect(() => {
    // Fetch products from Firestore instead of Axios
    const fetchProducts = async () => {
      try {
        const querySnapshot = await getDocs(collection(db, "products"));
        const productsFromFirestore = querySnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));

        setAllProducts([...productsFromFirestore]);
        setProducts([...productsFromFirestore]);
      } catch (error) {
        console.error("Error fetching products: ", error);
      }
    };

    fetchProducts();
  }, [open]);

  const formik = useFormik({
    initialValues: {
      gender: "",
      category: "",
      colors: "",
      priceRange: "",
      rating: "",
    },
    onSubmit: () => {
      setOpenFilter(false);
    },
  });

  const { resetForm, handleSubmit } = formik;

  const handleOpenFilter = () => {
    setOpenFilter(true);
  };

  const handleCloseFilter = () => {
    setOpenFilter(false);
  };

  const handleResetFilter = () => {
    handleSubmit();
    resetForm();
    setProducts(allProducts);
  };

  const handleReload = () => {
    handleSubmit();
  
    const searchResults = allProducts.filter((infos) => {
      // Ensure colors are always treated as an array
      const colors = Array.isArray(formik.values.colors) ? formik.values.colors : [];
      const productColors = Array.isArray(infos.colors) ? infos.colors : [];
      
      // Combine the colors
      const mergedColors = new Set([...colors, ...productColors]);
  
      // Check if the merged set size differs from the original colors length
      return mergedColors.size !== productColors.length;
    });
  
    setProducts(searchResults);
  };
  

  const handleNewProduct = () => {
    setOpen(!open);
  };

  return (
    <Page title="Dashboard: Products | Ballarat Squash and Racquetball">
      <Container>
        <Typography variant="h4" sx={{ mb: 5 }}>
          Products
        </Typography>

        <Stack
          direction="row"
          alignItems="center"
          justifyContent="flex-end"
          mb={5}
          spacing={2}
        >
          <Button
            variant="contained"
            component={RouterLink}
            to="#"
            startIcon={<Iconify icon="eva:plus-fill" />}
            onClick={handleNewProduct}
          >
            New Product
          </Button>
        </Stack>

        <AddProduct isOpen={open} toggle={handleNewProduct} />
        <Stack
          direction="row"
          flexWrap="wrap-reverse"
          alignItems="center"
          justifyContent="flex-end"
          sx={{ mb: 5 }}
        >
          <Stack direction="row" spacing={1} flexShrink={0} sx={{ my: 1 }}>
            <ProductFilterSidebar
              formik={formik}
              isOpenFilter={openFilter}
              onResetFilter={handleResetFilter}
              onOpenFilter={handleOpenFilter}
              onCloseFilter={handleCloseFilter}
              onReload={handleReload}
            />
            <ProductSort />
          </Stack>
        </Stack>

        <ProductList products={products} />
      </Container>
    </Page>
  );
}
